import { VEHICLE_ID_PROP_NAME } from '../constants';
import injectParams from '../utils/injectParams';
import PropProvider from '../PropProvider';
import { breadcrumbsConnectDefaults } from '../utils/ConnectDefaults';
import AssetCurrentLocation from '../components/AssetCurrentLocation';

export default injectParams(breadcrumbsConnectDefaults(
  AssetCurrentLocation,
  (state, ownProps) => PropProvider(state).AssetCurrentLocation(ownProps[VEHICLE_ID_PROP_NAME]),
  'au.section.title.vehicles',
  'details'
));
